(function () {
    // Collect all timelines (supports multiple instances on the page)
    var sections = document.querySelectorAll('.scrolling-timeline.page-block');
    if (!sections.length) return;

    // Collect all items from all sections
    var items = [];
    sections.forEach(function (section) {
        items.push.apply(items, section.querySelectorAll('.timeline .timeline-item'));
    });
    if (!items.length) return;

    // Prefer IntersectionObserver if available
    if ('IntersectionObserver' in window) {
        // rootMargin: cut 25% off the bottom of the viewport,
        // so "visible" means within the top 75% of the viewport
        var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-opaque');
            } else {
                entry.target.classList.remove('is-opaque');
            }
            });
        }, {
            root: null,
            rootMargin: '0px 0px -25% 0px',
            threshold: 0
        });

        items.forEach(function (el) { io.observe(el); });
    } else {
        // Fallback: rAF-throttled scroll/resize (works for many items too)
        var ticking = false;

        function checkAll() {
            var viewportH = window.innerHeight || document.documentElement.clientHeight;
            var activationY = viewportH * 0.75;

            items.forEach(function (el) {
                var r = el.getBoundingClientRect();
                var onScreen = r.bottom >= 0 && r.top <= viewportH;
                if (onScreen && r.top <= activationY) {
                    el.classList.add('is-opaque');
                } else {
                    el.classList.remove('is-opaque');
                }
            });
        }

        function onScrollOrResize() {
            if (!ticking) {
                requestAnimationFrame(function () {
                    checkAll();
                    ticking = false;
                });
                ticking = true;
            }
        }

        window.addEventListener('scroll', onScrollOrResize, { passive: true });
        window.addEventListener('resize', onScrollOrResize);
        checkAll(); // initial pass
    }
})();